import React, {Fragment} from 'react';
import {Grid} from 'semantic-ui-react';

import HomepageSection from 'components/homepage-layouts/HomepageSection';

class HomepageLayout extends React.Component {

  render() {
    return  <Fragment>
              {this.props.layout.sections ?
                <Fragment>
                  {this.props.layout.sections.map((section, i) => (
                    <HomepageSection  section={section} />
                  ))}
                </Fragment>
              : ""}
            </Fragment>
  }

}

export default HomepageLayout;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/HomepageLayout.jsx